import { takeLatest, put, call, all } from 'redux-saga/effects';
import { fetchTags, fetchTeasers, fetchTeaserCount, fetchPerson } from '../services/api';
import { reactAppLoaded } from '../services/reactLoadTracker';

import { actionTypes } from '../actions/actionTypes';
import { actions } from '../actions/actionCreators';

export default function* sagas() {
	yield all([
		watchTagsSaga(),
		watchTeasersSaga(),
		watchFilterSaga(),
		watchPaginationSaga(),
		watchFilterCountSaga(),
		watchPersonSaga()
	])
}

function* watchTagsSaga() {
	yield takeLatest(actionTypes.tag.FETCH, fetchTagsSaga)
}

function* watchTeasersSaga() {
	yield takeLatest(actionTypes.teaser.FETCH, fetchTeasersSaga)
}

function* watchFilterSaga() {
	yield takeLatest(actionTypes.filter.UPDATE, fetchTeasersSaga)
}

function* watchFilterCountSaga() {
	yield takeLatest(actionTypes.filter.COUNT, fetchTeaserCountSaga)
}

function* watchPaginationSaga() {
	yield takeLatest(actionTypes.filter.PAGINATE, fetchMoreTeasersSaga)
}

function* watchPersonSaga() {
	yield takeLatest(actionTypes.person.FETCH, fetchPersonSaga)
}

export function* fetchPersonSaga(action) {
	try {
		const personData = yield call(fetchPerson, action.payload);
		yield put(actions.person.set(personData));
	} catch (error) {
		yield put(actions.teaser.fetchFailed());
	}
}

export function* fetchMoreTeasersSaga(action) {
	yield put(actions.system.loading(true, 'pagination'));

	try {
		const teaserData = yield call(fetchTeasers, action.payload.filter, action.payload.pagination);
		yield put(actions.teaser.add(teaserData));

		yield put(actions.filter.remaining(!(teaserData.data.length < action.payload.pagination.limit)));
	} catch (error) {
		yield put(actions.teaser.fetchFailed(error.message));
	} finally {
		yield put(actions.system.loading(false, 'pagination'));
	}
}

export function* fetchTagsSaga(action) {
	yield put(actions.system.loading(true, 'filter'));

	try {
		const tagData = yield call(fetchTags, action.payload);
		yield put(actions.tag.set(tagData));
	} catch (error) {
		yield put(actions.tag.fetchFailed(error.message));
	} finally {
		yield put(actions.system.loading(false, 'filter'));
	}
}

export function* fetchTeasersSaga(action) {

	yield put(actions.system.loading(true, 'filter'));

	try {
		const teaserData = yield call(fetchTeasers, action.payload.filter, action.payload.pagination || null);
		yield put(actions.teaser.set(teaserData));
		yield put(actions.filter.remaining(!(teaserData.data.length < action.payload.pagination.limit)));
	} catch (error) {
		yield put(actions.teaser.fetchFailed(error.message));
	} finally {
		yield put(actions.system.loading(false, 'filter'));
		reactAppLoaded();
	}
}

export function* fetchTeaserCountSaga(action) {
	yield put(actions.system.loading(true, 'filter'));

	try {
		const teaserCount = yield call(fetchTeaserCount, action.payload);
		yield put(actions.teaser.count(teaserCount.data));
	} catch (error) {
		yield put(actions.teaser.fetchFailed(error.message));
	} finally {
		yield put(actions.system.loading(false, 'filter'));
	}
}


// WEBPACK FOOTER //
// ./src/sagas/index.js